// Generated by scripts/build-info.mjs - do not edit, not committed.
export const BUILD_INFO = {
  sha: '5f93aede43f1c3a9a940021381669789a718b239',
  short: '5f93aed',
  builtAt: '2026-11-04T00:51:31.377Z',
} as const;
